// ==============================|| OVERRIDES - PAGINATION ITEM ||============================== //

export default function PaginationItem(theme) {
	return {
		MuiPaginationItem: {
			styleOverrides: {}
		}
	};
}
